import { ResourceModel, Field } from '@smartsoftware/reflex-core';
import { DexResourceModel } from '../abstracts/dexResource.model';

export class SuccessCaseAccess extends DexResourceModel {

    @Field(String)
    public case_uuid: string = "";
    @Field(String)
    public successAccount_uuid: string = "";

    constructor(data?: any) {
        super();
        this.mapData(data);
    }

}
